import Checkbox from 'components/ui/Checkbox';
import Button from 'components/ui/Button';
import styled from 'styled-components';

export const GridTable = styled.div`
  display: grid;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  grid-template-columns: repeat(${(props) => props.rows}, minmax(min-content, min-content));
  font-weight: normal;
  margin-top: 16px;
`;

export const GridHeaderCell = styled.div`
  font-weight: bold;
  padding: 0;
  white-space: nowrap;
`;
export const GridCell = styled.div`
  padding: 0;
  white-space: nowrap;
`;

export const GridCheckBox = styled(Checkbox)``;

export const UpdateButton = styled(Button)`
  float: right;
`;
